// extracted by mini-css-extract-plugin
export var checkoutHoverCard = "_mi-2";
export var interactiveWrapper = "_mi-0";
export var shippingHoverPreview = "_mi-4";
export var summaryBadgeTrigger = "_mi-1";
export var widgetHoverPreviewList = "_mi-3";
export var widgetPreviewScale = "_mi-5";